import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getShelled } from 'services/glass-management/glassManagement';

export const fetchShelled = createAsyncThunk('glass/shelled/fetch', async (filters, { signal }) => {
    const res = await getShelled(filters, signal);
    return { data: res };
});

export const shelledSlice = createSlice({
    name: 'glassShelled',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchShelled.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShelled.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchShelled.rejected, (state, action) => {
                // Do nothing if aborted to continue loading
                if (action.meta.aborted)
                    return;

                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load shelled';
                state.data = null;
            });
    }
});

export default shelledSlice.reducer;
